const resize = (container) => {
  container.style.height = container.children[0].clientHeight + 'px';
}

export default resize